<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{checkModuleIndex('USTR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['USTR']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <div class="searchCol" v-if="!hideBrand">
                                <span class="searchLabel">{{this.getLanguage['GL']['AGT']}} :</span>
                                <customtreeselect :multiple="true"
                                            :limit="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :limitText="count => `+${count}`"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="false"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MT"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_userType"
                                            :placeholder="this.utilGetDDLanguage('MT.MT')"
                                            v-model="searchIsTester" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage['BTN']['SR']}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <div>
                        <!--<strong>{{//this.memberName}} {{//this.getLanguage['WLRPT']['WLR']}} </strong>-->
                        <small>{{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}}</small>

                    </div>

                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="stickyLeft">{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th class="stickyLeft" v-if="!hideBrand">
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                </th>
                                <th class="stickyLeft">
                                    {{this.getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['PM']['GPROV']}}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BI']}}
                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['G']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BB']}}
                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                </th>
                                <!-- <th>{{this.getLanguage['CYT']['BCBA']}}</th>-->
                                <!-- <th>{{this.getLanguage['CYT']['BCWLA']}}</th>-->
                                <th>
                                    {{this.getLanguage['BETRPT']['BA']}}
                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BT']}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <!--<th>
                                    {{//this.getLanguage['BETRPT']['ET']}}
                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')"></i>
                                </th>-->

                                <th class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['IP']}}
                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="stickyLeft">{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th class="stickyLeft" v-if="!hideBrand">
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                </th>
                                <th class="stickyLeft">
                                    {{this.getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['PM']['GPROV']}}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BI']}}
                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['G']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BB']}}
                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                </th>
                                <!-- <th>{{this.getLanguage['CYT']['BCBA']}}</th>-->
                                <!-- <th>{{this.getLanguage['CYT']['BCWLA']}}</th>-->
                                <th>
                                    {{this.getLanguage['BETRPT']['BA']}}
                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BT']}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <!--<th>
        {{//this.getLanguage['BETRPT']['ET']}}
        <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')"></i>
    </th>-->

                                <th class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['IP']}}
                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_provider_reportList == null || arr_provider_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_provider_reportList">
                            <tr>
                                <td class="stickyLeft">{{ CountItem(index+1) }}</td>
                                <td class="stickyLeft" v-if="!hideBrand">
                                    <Span class="grid-line">{{ data.AGN }}</Span>
                                    <span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</span>
                                </td>
                                <td class="stickyLeft">{{ data.ISOC }}</td>
                                <td v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="kema-eft" @click="CheckingMember(data.AGI,data.MI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <td v-else-if="(isSENS == 1 && data.AGI != curAGI)" class="kema-eft">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <td>{{ getProvName(data.PN) }}</td>
                                <td>{{ data.TI }}</td>
                                <!--<td :colspan="gameNameColspan()">{{ //getGN(data.GPN, data.GN) }}</td>-->
                                <td style="max-width: 150px; word-break: break-word; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ getGN(data.PN, data.GN) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TBB, 2, data.ISOC, false) }}</td>
                                <!--<td class="tableCtnRight">{{ //formatNumber(data.BCBA, 2, data.ISOC, false) }}</td>
                                <td :class="CheckWinLoss(data.BCWLA,data.RS,data.BCWLA)" class="tableCtnRight">{{ //formatNumber(data.BCWLA, 2, data.ISOC, false) }}</td> -->
                                <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                <!--<td>{{ //generateEndTime(data.RS, data.CTS, data.RTS) }}</td>-->
                                <td class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00/0.00/0.00/0.00/0.00</span>
                                    <span v-else>{{ formatPT(data) }}</span>
                                </td>
                                <td>{{ data.MIP }}</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import { constWinLossType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddGameProviderList: null,
                ddWinLossTypeList: constWinLossType,
                ddMemberList: null,
                ddDefaultMemberList: null,
                // ddDefaultMemberTypeList: null,
                dd_userType: [],
                // search fields
                searchAgi: 0,
                searchAgent: null,
                searchUserId: null,
                searchUserType: null,
                searchUsername: null,
                searchGameProviderId: [],
                searchRegisterSourceName:null,
                //searchWinLossType: null,
                searchIsTester: null,
                // searchBetId:null,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                arr_provider_reportList: {},
                arr_summary_reportList: [],
                reportType: "summary",
                skipPageUpdate: false,
                dd_memberKey: 0,
                memberName: "",
                DataLastUpdatedTS: "-",
                shareIndicator: "",
                constAccessType: constAccessType,
                str_summary_tableSortBy: "", //(sort summary table col name)
                bool_summary_isSort: true, // summary Table Ascending Descending
                hideBrand: false,
                arry_vdp: [],
                searchVDP: null,
                searchGameCategoryIds: null,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}

                //this.searchAgi = 0;
                //if (value) {
                //    var agentList = value.split("-");
                //    this.searchAgi = agentList[agentList.length - 1];
                //}
                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                //var agentGId = null;

                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }

                if (this.searchGameCategoryIds) {
                    path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                }

                if (this.searchGameProviderId) {
                    //path += "&f.GPI=" + this.searchGameProviderId;
                    path += "&f.GPI_csv=" + this.searchGameProviderId;
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                if (this.searchIsTester) {
                    path += "&f.ITU=" + this.searchIsTester;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.getDataApi("/api/reports/unsettle" + `?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.DataLastUpdatedTS = that.getLUTS(d.D.Items);
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_provider_reportList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });

            },
            saveToExcel() {

                if (this.reportType != null) {
                    this.bool_fullLoading = false;
                    var that = this;
                    //var agentGId = null;

                    //if (this.searchAgi > 0) {
                    //    agentGId = this.searchAgi;
                    //}

                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }

                    //if (agentGId) {
                    //    path += "&f.AGI=" + agentGId;
                    //}
                    if (this.searchAgi) {
                        path += "&f.AGI_csv=" + this.searchAgi;
                    }

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchGameCategoryIds) {
                        path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                    }

                    if (this.searchGameProviderId) {
                        //path += "&f.GPI=" + this.searchGameProviderId;
                        path += "&f.GPI_csv=" + this.searchGameProviderId;
                    }

                    if (this.searchIsTester) {
                        path += "&f.ITU=" + this.searchIsTester;
                    }

                    path += "&f.RT=" + this.reportType;
                    path += "&f.LC=" + this.getLangCode;

                    if (this.searchCreatedTS) {
                        if (this.searchCreatedTS.startDate != "") {
                            path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        }

                        if (this.searchCreatedTS.endDate != "") {
                            path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        }
                    }
                    if (this.searchVDP) {
                        path += "&f.VDP=" + this.searchVDP;
                    }
                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }
                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    window.open('/api/reports/unsettledticketexcel?' + path, '_blank');
                }
            },
            getLUTS(items) {
                if (items != null && items.length > 0) {
                    var result = moment(items[items.length - 1].UTS).format("MMM DD, YYYY hh:mm a");
                    try {
                        //new Date(Math.max.apply(null, items.map(function(e) {
                        //    var temp = new Date(e.UTS);
                        //    result = moment(temp).format("MMM DD, YYYY hh:mm a");
                        //})));
                        var temp = new Date(items[0].UTS);
                        for (var i = 0; i < items.length; i++) {
                            var curDT = new Date(items[i].UTS);
                            if (curDT > temp) {
                                temp = curDT;
                            }
                        }
                        result = moment(temp).format("MMM DD, YYYY hh:mm a");;
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                    return result
                }
            },
            getGameName(name) {
                if (this.reportType == "AFB1188") {
                    if (name == "PAR") {
                        name = this.reportType + "_" + name;
                    }
                    else {
                        return name;
                    }
                }
                else if (this.reportType == "TFG_ESPORTS") {
                    if (name) {
                        name = name.replace('tfg_combo', this.getLanguage["TFG_ESPORTS"]["COMBO"]);
                    }

                    return name;
                }
                else if (this.reportType == "DIAMONDCLUB") {
                    name = this.reportType + "_" + name;
                }
                else if (this.reportType == "CQ9_LIVE_CASINO") {
                    name = this.reportType + "_" + name;
                }

                var gamename = name;

                if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {
                    gamename = this.getLanguage[this.reportType][name];
                }

                return gamename;
            },
            getProvName(name) {
                var pname = name;
                pname = this.getLanguage["GP"][name];

                return pname;
            },
            getGN(PN, GN) {
                var result = GN;
                try {
                    result = this.getLanguage[PN][GN];
                    if (result === "") {
                        return GN;
                    }
                    else {
                        return result;
                    }
                }
                catch (e) { }
                //if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {

                //}
                return result;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            formatPT(data) {
                var result = '';
                switch (this.getUserInfo.AT) {
                    case 0:
                        var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);

                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(PLA) +
                                "/" + this.formatNumber(data.WLS) +
                                "/" + this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.AWLS);

                        }
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');
                var tempLeft = 0;

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) {
                            headerCells[index].style.width = width;
                            headerCells[index].style.left = (index < 3) ? `${tempLeft}px` : '';
                            headerCells[index].style.zIndex = (index < 3) ? `3` : '';
                        }
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.left = (index < 3) ? `${tempLeft}px` : '');
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.zIndex = (index < 3) ? `3` : '');
                        tempLeft += parseFloat(width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.USTR';
            if (this.checkModuleIndex('USTR', 'R', constAccessType.view, '', -1) == '7.2.10') {
                this.$parent.showSubSubMenu = 'RS2';
            } else if (this.checkModuleIndex('USTR', 'R', constAccessType.view, '', -1) == '7.5.6') {
                this.$parent.showSubSubMenu = 'RS5';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.searchUserId = this.$route.query.i;
            this.searchUserType = this.$route.query.ut;
            this.searchUsername = this.$route.query.u;
            this.searchAgi = this.$route.query.agi;

            if (this.$route.query.gpi) {
                this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
            }
            if ((this.searchUserType) && (this.searchUserType > 0)) {
                this.searchIsTester = this.searchUserType;
            }
            if (this.searchAgi > 0) {
                this.searchAgent = '3-' + this.searchAgi;
            }

            this.getMemberTypeList();
            if (this.$route.path != this.$route.fullPath)
                this.getReportList();

            this.getVDP();
        },
        watch: {
            getLanguage() {
                this.getReportList();
                this.getVDP();
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/UnsettledTickets.vue